export const REQUEST_BANNER_LIST = 'zola/wedding/website/banner/REQUEST_BANNER_LIST'
export const RECEIVE_BANNER_LIST = 'zola/wedding/website/banner/RECEIVE_BANNER_LIST';
export const RECEIVE_BANNER_ID = 'zola/wedding/website/banner/RECEIVE_BANNER_ID';



// WEBPACK FOOTER //
// ./src/actions/types/website/BannerActionTypes.js